export default __webpack_public_path__ + "static/media-01-3b53486a44b4df709e153fa71075b90d.png";